// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import ScrollBooster from 'scrollbooster';

const swiper = {
    settings: [
        {
            handle: 'brandImages',
            settings: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [Navigation, Pagination, Autoplay]
            }
        },
        {
            handle: 'brandCarousel',
            settings: {
                slidesPerView: 1.25,
                spaceBetween: 10,
                centeredSlides: true,
                watchSlidesProgress: true,
                loop: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Autoplay],
                breakpoints: {
                    640: {
                        slidesPerView: 1.5,
                        spaceBetween: 24
                    }
                }
            }
        },
        {
            handle: 'timeline',
            settings: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                watchSlidesProgress: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Autoplay]
            }
        },
        {
            handle: 'timelineThumbs',
            settings: {
                slidesPerView: 3,
                spaceBetween: 0,
                breakpoints: {
                    480: {
                        slidesPerView: 4,
                    },
                    640: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 7,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [Pagination],
            }
        },
        {
            handle: 'stampCardsMobile',
            settings: {
                slidesPerView: 'auto',
                spaceBetween: 24,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [Pagination],
            }
        }
    ],
    init: function() {
        const self = this;
        const swiperElements = document.querySelectorAll('.swiper');

        if (!swiperElements.length) return;

        swiperElements.forEach(swiperElement => {
            const handle = swiperElement.dataset.swiperHandle ?? null;

            if (handle == 'brandCarouselThumbs' || handle == 'timelineThumbs') return;

            const settings = self.settings.find(setting => setting.handle === handle)?.settings ?? {};

            settings.on = {
                init: function () {
                    swiperElement.classList.add('!opacity-100');
                }
            };

            const swiperInstance = new Swiper(swiperElement, settings);

            if (handle == 'timeline' || handle == 'brandCarousel' || handle == 'brandImages') {
                const autoplayButton = swiperElement.querySelector('.swiper-button-autoplay');

                if (autoplayButton) {
                    autoplayButton.addEventListener('click', function () {

                        if (autoplayButton.classList.contains('is-active') && swiperInstance.autoplay) {
                            // toggle autoplay
                            swiperInstance.autoplay.start();
                            autoplayButton.classList.remove('is-active');
                        } else {
                            // toggle autoplay
                            swiperInstance.autoplay.stop();
                            autoplayButton.classList.add('is-active');
                        }
                    });
                }
            }

            if (handle == 'timeline') {
                const thumbsSwiperElement = swiperElement.nextElementSibling;

                if (!thumbsSwiperElement) return;

                const thumbsSwiperHandle = (handle + 'Thumbs');

                const settings = self.settings.find(setting => setting.handle === thumbsSwiperHandle)?.settings ?? {};
                settings.on = {
                    init: function () {
                        thumbsSwiperElement.classList.add('!opacity-100');
                    }
                };
                
                const thumbsSwiperInstance = new Swiper(thumbsSwiperElement, settings);

                // Custom sync logic between main and thumb swipers
                // When main swiper changes, update thumb swiper
                swiperInstance.on('slideChange', function () {
                    thumbsSwiperInstance.slideToLoop(this.realIndex);

                    // remove .swiper-slide-active from all thumbs
                    thumbsSwiperElement.querySelectorAll('.swiper-slide').forEach(function (slide) {
                        slide.classList.remove('is-active');
                    });

                    // .swiper-slide-active to the respective thumb
                    const respectiveThumb = thumbsSwiperElement.querySelector('.swiper-slide[data-swiper-slide-index="' + this.realIndex + '"]');

                    if (respectiveThumb) {
                        respectiveThumb.classList.add('is-active');
                    }
                });

                // Sync initial positions
                swiperInstance.on('init', function () {
                    thumbsSwiperInstance.slideTo(this.realIndex);
                });

                thumbsSwiperInstance.on('init', function () {
                    swiperInstance.slideTo(this.realIndex);
                });

                // On thumb click, update main swiper
                thumbsSwiperInstance.on('click', function (event) {
                    if (event.clickedSlide) {
                        const clickedSlide = event.clickedSlide;
                        // Get the data-swiper-slide-index attribute which contains the real slide index
                        const slideIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index') ?? '0');
                        swiperInstance.slideToLoop(slideIndex);
                    }
                });
            }

            if (handle == 'brandCarousel') {
                const swiperNav = swiperElement.nextElementSibling;
                if (swiperNav && swiperNav.classList.contains('swiperNav')) {
                    // Keep this for now, we can re-enable this if we need to navigate manually
                    // self.initScrollBooster(swiperNav);
                    self.initCustomNavSync(swiperInstance, swiperNav);
                }
            }
        });
    },
    /*
    initScrollBooster: function(element) {
        new ScrollBooster({
            viewport: element,
            content: element,
            scrollMode: 'native',
            direction: 'horizontal',
            bounce: false,
            textSelection: false,
            pointerMode: 'all'
        });

        // Set cursor styles
        element.style.cursor = 'grab';
        
        element.addEventListener('mousedown', () => {
            element.style.cursor = 'grabbing';
        });
        
        element.addEventListener('mouseup', () => {
            element.style.cursor = 'grab';
        });
        
        element.addEventListener('mouseleave', () => {
            element.style.cursor = 'grab';
        });
    },
    */
    initCustomNavSync: function(swiperInstance, swiperNav) {
        let activeIndex = 0;
        let activeGroupIndex = 1;
        let isAnimating = false;

        let isSwiperInit = false;
        let initCheckInterval;

        // Check if swiper is initialized
        initCheckInterval = setInterval(() => {
            if (swiperInstance.el && swiperInstance.el.classList.contains('swiper-initialized')) {
                isSwiperInit = true;
                clearInterval(initCheckInterval);
                scrollNavToIndex(activeIndex, 'instant');
                swiperNav.classList.add('!opacity-100');
            }
        }, 100);

        const updateActive = (index) => {
            const items = swiperNav.querySelectorAll('.swiperNavSlide');

            items.forEach((el) => {
                const i = parseInt(el.getAttribute('data-swiper-slide-index') || '0');

                if (i === index) {
                    el.classList.add('swiperNavSlide-active');
                } else {
                    el.classList.remove('swiperNavSlide-active');
                }
            });
        };

        const centerElement = (el, behavior = 'smooth') => {
            if (!el) return;
            
            requestAnimationFrame(() => {
                const left = el.offsetLeft + (el.offsetWidth / 2) - (swiperNav.clientWidth / 2);
                const max = Math.max(0, swiperNav.scrollWidth - swiperNav.clientWidth);
                const clamped = Math.min(max, Math.max(0, left));
                
                if (behavior === 'smooth') {
                    isAnimating = true;
                    const targetScroll = clamped;
                    swiperNav.scrollTo({ left: clamped, behavior });
                    
                    // More accurate animation end detection
                    let lastScrollLeft = swiperNav.scrollLeft;
                    let stableCount = 0;
                    
                    const checkScrollComplete = () => {
                        const currentScroll = swiperNav.scrollLeft;
                        const tolerance = 1; // 1px tolerance
                        
                        // Check if we're close to target and scroll has stabilized
                        if (Math.abs(currentScroll - targetScroll) <= tolerance && 
                            Math.abs(currentScroll - lastScrollLeft) <= tolerance) {
                            stableCount++;
                            if (stableCount >= 3) { // 3 consecutive stable readings
                                isAnimating = false;
                                return;
                            }
                        } else {
                            stableCount = 0;
                        }
                        
                        lastScrollLeft = currentScroll;
                        
                        if (isAnimating) {
                            requestAnimationFrame(checkScrollComplete);
                        }
                    };
                    
                    // Start checking
                    requestAnimationFrame(checkScrollComplete);
                    
                    // Absolute fallback
                    setTimeout(() => {
                        isAnimating = false;
                    }, 600);
                } else {
                    swiperNav.scrollTo({ left: clamped, behavior });
                }
            });
        };

        const scrollNavToIndex = (index, behavior = 'smooth') => {
            const target = swiperNav.querySelector('.swiperNavSlide[data-swiper-group-index="' + activeGroupIndex + '"]' + '[data-swiper-slide-index="' + index + '"]');
            centerElement(target, behavior);
            updateActive(index);

            // If groupIndex is not 1, then we need to update the activeGroupIndex
            if (activeGroupIndex !== 1) {
                const targetBase = swiperNav.querySelector('.swiperNavSlide[data-swiper-group-index="1"]' + '[data-swiper-slide-index="' + index + '"]');
                
                const checkAndSnap = () => {
                    if (isAnimating) {
                        requestAnimationFrame(checkAndSnap);
                        return;
                    }
                    activeGroupIndex = 1;
                    centerElement(targetBase, 'instant');
                };
                
                requestAnimationFrame(checkAndSnap);
            }
        };

        // Main swiper -> nav
        swiperInstance.on('slideChange', function() {
            if (!isSwiperInit) return;
            
            const index = this.realIndex;
            activeIndex = index;
        });

        swiperInstance.on('slideNextTransitionStart', function() {
            if (!isSwiperInit) return;
            
            const index = this.realIndex;

            requestAnimationFrame(() => {
                // If index == 0, then we need to update the activeGroupIndex
                if (index == 0) {
                    activeGroupIndex = (activeGroupIndex + 1) || 2;
                    scrollNavToIndex(index);

                    setTimeout(() => {
                        requestAnimationFrame(() => {
                            const targetBase = swiperNav.querySelector('.swiperNavSlide[data-swiper-group-index="1"]' + '[data-swiper-slide-index="' + index + '"]');
                            centerElement(targetBase, 'instant');
                        });
                    }, 450);
                } else {
                    scrollNavToIndex(index);
                }
            });
        });

        swiperInstance.on('slidePrevTransitionStart', function() {
            if (!isSwiperInit) return;
            
            const previousIndex = this.previousRealIndex;
            const index = this.realIndex;

            requestAnimationFrame(() => {
                // If previousIndex == 0, then we need to update the activeGroupIndex
                if (previousIndex == 0) {
                    activeGroupIndex = (activeGroupIndex - 1) || 0; 
                    scrollNavToIndex(index);

                    setTimeout(() => {
                        requestAnimationFrame(() => {
                            const targetBase = swiperNav.querySelector('.swiperNavSlide[data-swiper-group-index="' + activeGroupIndex + '"]' + '[data-swiper-slide-index="' + index + '"]');
                            centerElement(targetBase, 'instant');
                        });
                    }, 450);
                } else {
                    scrollNavToIndex(index);
                }
            });
        });

        // Nav -> main swiper
        swiperNav.addEventListener('click', (e) => {
            if (!isSwiperInit) return;
            
            const li = e.target.closest('.swiperNavSlide');
            if (!li) return;
            e.preventDefault();

            const index = li.getAttribute('data-swiper-slide-index') ?? 0;
            const groupIndex = li.getAttribute('data-swiper-group-index') ?? 0;

            activeIndex = parseInt(index);
            activeGroupIndex = parseInt(groupIndex);

            swiperInstance.slideToLoop(index);

            centerElement(li, 'smooth');
        });
    }
}

export default swiper;
